export default __webpack_public_path__ + "images/63087592a18483decdbce7d202f00dd0.svg";